import * as React from 'react';
import {IConsoleMessage} from '../../redux/modules/console/reducer';

export interface IConsoleLineProps {
  message: IConsoleMessage;
  style?: any;
}

export const ConsoleLine: React.StatelessComponent<IConsoleLineProps> =
({message, style}: IConsoleLineProps) => (
  <div className={`console-component--line console-component--line-${message.type}`} style={style}>
    {message.data}
  </div>
);
